import * as React from "react";
const SvgBackArrow = props => <svg width={20} height={20} viewBox="0 0 80 80" id="svg1" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M 0,40 28.6,16 V 30 C 72.5,30.4 80,75 80,75 80,75 63.7,51.3 28.6,51 v 13 z" /></svg>;
export default SvgBackArrow;